// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c7106b7806b13826597a","340":"63d23348a731b3c2f246","413":"3f8ae0e9c6fe7ed4d044","453":"9877cd314d4414c3dc8f","540":"3e99bac223586700e267","563":"b90f0ae2d7c4d84a68ac","944":"25be4f2529b23eb57db2"}[chunkId] + ".v2.5.26.chunk.js";
};